import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import React, {useEffect, useState} from "react";
import {QuestsCategoryModel,QuestsModel} from "../../Api/Models/quests.model";
import { QuestsService } from "../../Api/Services/QuestsService";
import { useInfoModal } from "../../Context/InfoModalProvider";
import {LongArrowLeftIcon} from "../../Components/Icons/LongArrowLeftIcon";
import { getCachedQuestCategories, setCachedQuestCategories } from "../../Utils/questCache";



const NewQuest: React.FunctionComponent<object> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { showInfo } = useInfoModal();

    const [questCategories,setquestCategories] = useState<QuestsCategoryModel[]>([]);

    useEffect(() => {
        const fetchQuestCategories = async () => {
            try {
                const cached = getCachedQuestCategories();
                if (cached) {
                    setquestCategories(cached);
                    return;
                }

                const result = await new QuestsService().getQuestCategories();
                setquestCategories(result);
                setCachedQuestCategories(result);
            } catch (error) {
                console.error("❌ Error fetching quest categories:", error);
            }
        };

        fetchQuestCategories();
    }, []);

    //const [questLengthHours, setQuestLengthHours] = useState(0);
    //const [questLengthMinutes, setQuestLengthMinutes] = useState(0);
    const [questStartDate, setQuestStartDate] = useState<string>("");
    const [questEndDate, setQuestEndDate] = useState<string>("");
    const [questName, setQuestName] = useState("");
    const [questCategory, setQuestCategory] = useState<number | null>(null);
    const [address, setAddress] = useState("");
    //const [comment, setComment] = useState("");
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);



    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);
        const newErrors: { [key: string]: string } = {};

        if (!questName.trim()) {
            newErrors.questName = t("Quest name is required");
        }
        if (!questCategory || questCategory === -1) {
            newErrors.questCategory = t("Quest category is required");
        }
        if (!questStartDate) {
            newErrors.questStartDate = t("Quest start date is required");
        }
        if (!questEndDate) {
            newErrors.questEndDate = t("Quest end date is required");
        }

        if (questStartDate && questEndDate) {
            const startDate = new Date(questStartDate);
            const endDate = new Date(questEndDate);

            if (startDate >= endDate) {
                newErrors.questEndDate = t("Quest end date must be after start date");
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitting(false);
            return;
        }

        setErrors({});

        const quest: QuestsModel = {
            id: 0,
            name: questName,
            questCategory: questCategory ?? 0,
            address: address || undefined,
            startDate: questStartDate,
            endDate: questEndDate,
            status: 1,
        };

        try {
            await new QuestsService().createQuest(quest);
            showInfo(t("Quest created successfully"));
            navigate("/quests");
        } catch (error) {
            console.error("Quest creation failed:", error);
            showInfo(t("Quest creation failed. Please try again later."));
            setIsSubmitting(false);
        }
    };
    const clearError = (field: string) => {
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[field];
            return newErrors;
        });
    };




    return (
        <div className="view-container background">
            <div className="view-content" style={{ paddingTop: "24px" }}>

                <div className="navigationbar navigationbar mb-6">
                    <div className="navigationbar__left">
                        <Link to="/quests" className="navigationbar__button">
                            <LongArrowLeftIcon />
                        </Link>
                    </div>
                    <div className="navigationbar__center">
                        <div className="navigationbar__title">{t("Quest Creation")}</div>
                    </div>
                    <div className="navigationbar__right">
                    </div>
                </div>

                <div>

                            <form className="flex flex-col items-center" onSubmit={handleSubmit}>
                                <label className="form-label text-white">{t("Quest Category")}*</label>
                                {errors.questCategory && <p className="text-blue font-14">{errors.questCategory}</p>}
                                <select
                                    value={questCategory ?? -1}
                                    onChange={(e) => {
                                        setQuestCategory(Number(e.target.value));
                                    if (errors.questCategory) clearError("questCategory");
                                    }}
                                    className="input-field text-blue see-through-background mb-2"
                                >
                                    <option value={-1}>{t("Select Category")}</option>
                                    {questCategories.map(category => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                                <label className="form-label text-white">{t("Quest Name")}*</label>
                                {errors.questName && <p className="text-blue font-14">{errors.questName}</p>}
                                <input
                                    type="text"
                                    value={questName}
                                    onChange={(e) => {
                                        setQuestName(e.target.value);
                                        if (errors.questName) clearError("questName");
                                    }}
                                    className='input-field text-blue see-through-background mb-2'
                                />
                                <label className="form-label text-white">{t("Location")}</label>
                                <input type="text"
                                       value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                       className="input-field text-blue see-through-background mb-2"
                                >

                                </input>
                                {/*<label className="form-label text-white">{t("Quest Length")}*</label>
                                {errors.questLength && <p className="text-blue font-14">{errors.questLength}</p>}
                                <div className="flex gap-4 mb-2 w-full">
                                    <div className="flex flex-col w-full text-center">
                                        <label htmlFor="questHours" className="text-centertext-xs text-white mb-1">{t("Hours")}</label>
                                        <input
                                            id="questHours"
                                            type="number"
                                            value={questLengthHours}
                                            min={0}
                                            className="input-field text-blue see-through-background w-full"
                                            placeholder="0"
                                            onChange={(e) => {
                                                setQuestLengthHours(parseInt(e.target.value));
                                                if (errors.questLength) clearError("questLength");
                                            }}
                                        />
                                    </div>

                                    <div className="flex flex-col w-full text-center">
                                        <label htmlFor="questMinutes" className="text-centertext-xs text-white mb-1">{t("Minutes")}</label>
                                        <input
                                            id="questMinutes"
                                            type="number"
                                            value={questLengthMinutes}
                                            min={0}
                                            max={59}
                                            className="input-field text-blue see-through-background w-full"
                                            placeholder="0"
                                            onChange={(e) => {
                                                setQuestLengthMinutes(parseInt(e.target.value));
                                                if (errors.questLength) clearError("questLength");
                                            }}
                                        />
                                    </div>
                                </div>*/}
                                <label className="form-label text-white">{t("Quest from")}*</label>
                                {errors.questStartDate && <p className="text-blue font-14">{errors.questStartDate}</p>}
                                <input
                                    type="datetime-local"
                                    className="input-field text-blue see-through-background mb-2"
                                    value={questStartDate}
                                    onChange={(e) => setQuestStartDate(e.target.value)}
                                />

                                <label className="form-label text-white">{t("Quest to")}*</label>
                                {errors.questEndDate && <p className="text-blue font-14">{errors.questEndDate}</p>}
                                <input
                                    type="datetime-local"
                                    className="input-field text-blue see-through-background mb-2"
                                    value={questEndDate}
                                    onChange={(e) => setQuestEndDate(e.target.value)}
                                />

                                {/*<label className="form-label text-white">{t("Comment")}</label>
                                <input type="text"
                                       value={comment}
                                       onChange={(e) => setComment(e.target.value)}
                                       className="input-field text-blue see-through-background mb-2"
                                >

                                </input>*/}
                                <div className="flex gap-2 mb-2 w-full">
                                    <button type="submit" className="button flex items-center justify-center gap-2" disabled={isSubmitting}>
                                        {isSubmitting && (
                                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="red" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="red" d="M4 12a8 8 0 018-8v8H4z"></path>
                                            </svg>
                                        )}
                                        {isSubmitting ? t("Submitting...") : t("Send Request")}
                                    </button>
                                </div>
                            </form>
            </div>
            </div>
        </div>
    );
};

export default NewQuest;